import { render } from "./About.vue?vue&type=template&id=60191b1a&scoped=true&bindings={\"isLoading\":\"data\",\"error\":\"data\",\"makeBooking\":\"data\",\"sendBooking\":\"data\",\"text\":\"options\",\"images\":\"options\",\"gallery\":\"options\",\"loadCategories\":\"options\",\"handleError\":\"options\",\"handleBooking\":\"options\",\"showSentDialog\":\"options\",\"handleSendBooking\":\"options\"}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=60191b1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60191b1a"

export default script